import React, { useEffect } from 'react'
import Swal from 'sweetalert2'

export default function Snackbar({
  type = 'error',
  message = '',
  position = 'center',
  duration = 3000,
  setError,
  link = null,
}) {
  useEffect(() => {
    const Toast = Swal.mixin({
      toast: false,
      position: position,
      showConfirmButton: true,
      timer: duration,
      timerProgressBar: true,
      didClose: () => {
        setError(link ? link : null, link ? 'link' : null)
      },
    })

    Toast.fire({
      icon: type,
      title: message,
    })
  }, [type, message, position, duration, setError, link])

  return null
}
